import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CurriculumService } from 'src/app/Services/curriculum.service';
import { IServiceFactory } from 'src/app/Services/service-factory';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { CreateAccountService } from 'src/app/Services/create-account.service';

@Component({
  selector: 'app-register-dialog',
  templateUrl: './register-dialog.component.html',
  styleUrls: ['./register-dialog.component.scss']
})
export class RegisterDialogComponent implements OnInit {
  valueUpdated = new EventEmitter<any>();
  curriculumID: string;
  registerForm: FormGroup;
  title: string;
  passwordHide = true;
  dataService: CurriculumService;
  userDataService: CreateAccountService;
  registerNewStudentWait: boolean = false;
  
  private searchTerms = new Subject<string>();

  constructor(
    public dialogRef: MatDialogRef<RegisterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private serviceFactory: IServiceFactory,) {
      this.curriculumID = data.curriculumID;
      this.title = data.title;
      this.dataService = serviceFactory.getCurriculumService();
      this.userDataService = this.serviceFactory.getCreateAccountService();
    }

  ngOnInit(): void {
    this.registerForm = this.fb.group({
      curriculumID: [this.curriculumID],
      StudentFirstName: ['', Validators.required],
      StudentLastName: ['', Validators.required],
      StudentEmail: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$')]],
      Password: ['', Validators.minLength(8)]
    });

    this.searchTerms.pipe(
      debounceTime(400), //waits 300 ms after last keyup to search again
      switchMap((term: string) => 
      this.userDataService.ValidateUsername(term)
        ),)
        .subscribe( result => {
          if(!result){
            this.toastr.error("That email is already in use.");
            this.registerForm.controls['StudentEmail'].setValue(null);
          }
       });
  }

  /**
   * This method is used to check for valid input.
   */
  isValidInput(fieldName): boolean {
    return this.registerForm.controls[fieldName].invalid &&
      (this.registerForm.controls[fieldName].dirty || this.registerForm.controls[fieldName].touched);
}

search(): void {// on keyup, the term is redfined
  var email = this.registerForm.controls['StudentEmail'];
  var term = email.value;
  if(email.errors == null){
    this.searchTerms.next(term);
  }
}

/**
 * This method is called to save Student form.
 */
  onSubmit = (form: FormGroup) => {
    if (!form.valid) {
      this.toastr.warning('Please fill all required fields', 'Warning!');
      return;
    }
    if(this.registerNewStudentWait){
      return;
    }
    else{
      this.registerNewStudentWait = true;
    }
    const values = this.registerForm.value;
    const params = {
      StudentFirstName: values.StudentFirstName,
      StudentLastName: values.StudentLastName,
      StudentEmail: values.StudentEmail,
      Password: values.Password
    }
    this.dataService.RegisterNewStudent(params).subscribe(res => {
      if (res) {
        this.toastr.success('Student Registered.', 'Success!');
        params['StudentID'] = res;
        this.valueUpdated.emit(params);
        this.registerNewStudentWait = false;
        this.dialogRef.close();
      } else {
        this.registerNewStudentWait = false;
        this.toastr.error('Something went wrong', 'Failure!');
      }
    })
    
  }

  onCancel = () => {
    this.valueUpdated.emit(false);
    this.dialogRef.close();
  }

  EnterSubmit($event, form:FormGroup){
    if($event.keyCode === 13){
      this.onSubmit(form);
    }
  }

}
